import { AppointmentStatus } from "types";

const useAppointmentStatus = (status: AppointmentStatus) => {
  const isCompleted = status === "completed";
  const isUpcoming = status === "upcoming";
  const isStarted = status === "started";
  const isHappening = isUpcoming || isStarted;

  return {
    isCompleted,
    isUpcoming,
    isStarted,
    isHappening,
  };
};

export default useAppointmentStatus;
